import { PlanState, PlanRequest } from 'Application/models';
import { createPlan as createPlanService, fetchAllPlans, fetchPlans, fetchSinglePlan, fetchTravelTypes } from 'Application/service';
import { create } from 'zustand';

export const useCreatePlanStore = create<PlanState>((set) => ({
    isLoading: false,
    isError: false,
    isTravelTypeLoading: false,
    isDownloadFileLoading: false,
    error: null,
    planData: [],
    fetchedPlans: [],
    allPlanData: [],
    travelTypesData: [],

    createPlan: async (planData: PlanRequest) => {
        set({ isLoading: true });

        try {
            await createPlanService(planData);
            set({ isError: false, error: null });
            await useCreatePlanStore.getState().getPlan(); // Refresh the list after creating a plan
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            set({ error: errorMessage, isError: true });
        } finally {
            set({ isLoading: false });
        }
    },

    getPlan: async () => {
        set({ isLoading: true });

        try {
            // Fetch the plans using your service here
            const plans = await fetchPlans();
            set({ fetchedPlans: plans, isError: false, error: null });
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            set({ error: errorMessage, isError: true });
        } finally {
            set({ isLoading: false });
        }
    },

    getTravelTypes: async (regionName?: string) => {
        set({ isTravelTypeLoading: true });

        try {
            // Fetch the plans using your service here
            const plans = await fetchTravelTypes(regionName);
            set({ travelTypesData: plans, isError: false, error: null });
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            set({ error: errorMessage, isError: true });
        } finally {
            set({ isTravelTypeLoading: false });
        }
    },

    getAllPlan: async (regionName) => {
        set({ isLoading: true });

        try {
            // Fetch the plans using your service here
            const plans = await fetchAllPlans(regionName);
            set({ allPlanData: plans, isError: false, error: null });
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            set({ error: errorMessage, isError: true });
        } finally {
            set({ isLoading: false });
        }
    },

    getSinglePlan: async (id: any) => {
        set({ isLoading: true });

        try {
            // Fetch the plans using your service here
            const plans = await fetchSinglePlan(id);
            set({ fetchedPlans: plans, isError: false, error: null });
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            set({ error: errorMessage, isError: true });
        } finally {
            set({ isLoading: false });
        }
    }
}));
